export default [
  {
    path: '/futures',
    name: 'futures',
    meta: {
      activeName: 'coTrade',
      footNotMrgin: true,
      pageTitle: 'select',
    },
    component: () => import('@/views/contract/index.vue'),
  },
  {
    path: '/futures/:symbol',
    name: 'futuresSymbol',
    meta: {
      activeName: 'coTrade',
      footNotMrgin: true,
      pageTitle: 'select',
    },
    component: () => import('@/views/contract/index.vue'),
  },
];
